export default __webpack_public_path__ + "4435c94e2e560bc7b6a14590c7ad4367.png";